export const fadeAnimation = {
  initial: {
    opacity: 0,
    y: '5vh',
  },

  animate: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'tween',
      duration: 1,
    },
  },
};
